export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "admin/api/login",
    GET_PROFILE: "admin/api/getProfile",
    FORGOT_PASSWORD: "admin/api/forgotpwd",
    RESET_PASSWORD: "admin/api/resetPassword",
    CHANGE_PASSWORD: "admin/api/changePassword",
    LOGOUT: "admin/api/logout",
    DOWNlOAD_EXCEL:'/admin/api/getTagsExcel'
  },
  LEAVE: {
    LEAVE_TYPE: "admin/api/getAllLeaveTypes",
    ADD_LEAVE_TYPE: "admin/api/addLeaveTypes",
    UPDATE_LEAVE_TYPE: "admin/api/updateLeaveType",
    GET_ALL_LEAVE_CONFIGURATION: "admin/api/getAllLeaveConfiguration",
    ADD_LEAVE_CONFIGURATION: "admin/api/addLeaveConfiguration",
    UPDATE_LEAVE_CONFIGURATION: "admin/api/updateLeaveConfiguration",
    GET_ALL_LEAVE_REQUESTS: "admin/api/getAllLeaveRequests",
    UPDATE_LEAVE_REQUESTS: "admin/api/updateLeaveRequest",
    GET_ALL_LEAVE_VIEW: "admin/api/leaveView",
    UPDATE_STATUS: "admin/api/leave/updateStatus",
    GET_LEAVE_VIEW_STATUS: "admin/api/leave/getLeaveStatusView",
    GET_LEAVE_STATUS: "admin/api/leave/getLeaveStatus",
    GET_LEAVE_BALANCE: "/admin/api/getEmpLeaveBalance",
    GET_POLICY_YEAR: "/admin/api/leave/getLeavePolicyYear",
    GET_ALL_LEAVE_REQUEST_EXCEL: "/admin/api/getAllLeaveRequestsExcel",
    GET_ALL_LEAVE_CONFIGURATION_EXCEL: "/admin/api/getAllLeaveConfigurationExcel",
    GET_EMP_LEAVE_BALANCE_EXCEL: "/admin/api/getEmpLeaveBalanceExcel",
    GET_LEAVE_REQUEST_EXCEL:'/admin/api/getAllLeaveRequestsExcel',
    GET_LEAVE_CONFIGURATION_EXCEL:'admin/api/getAllLeaveConfigurationExcel',
    // GET_LEAVE_BALANCE: "/admin/api/getEmployeeLeaveBalance",
  },
  EMPLOYEE: {
    GET_EMPLOYEE_LIST: "admin/api/getEmployeeList",
    GET_EMPLOYEE_STATUS: "admin/api/getEmployeeStatus",
    GET_DESIGNATIONS: "admin/api/getDesignations",
    GET_GRADE_MASTERS: "admin/api/getGradeMasters",
    GET_ORG_UNITS: "admin/api/getOrgUnits",
    GET_EMPLOYEE_DETAILS_BY_ID: "admin/api/getEmployeeById",
    GET_EMPLOYEE_POSITION: "admin/api/getEmployeePositions",
    GET_EMPLOYEE_REPORTING_TO: "admin/api/getEmployeeReportingToPosition",
    EDIT_EMPLOYEE_PROFILE: "admin/api/editEmployeeProfile",
    GET_DAY_LOCKED_LIST: "admin/api/getEmployeeList/locked",
    GET_DAY_LOCKED_DATE_BY_ID: "admin/api/getDayLockedDatesByEmployeeId",
    GET_ACCOUNT_LOCKED_LIST: "admin/api/getEmployeeList/freezed",
    RELEASE_ACCOUNT_LOCKED: "admin/api/releaseEmployeeAccountLock",
    RELEASE_DAY_LOCKED: "admin/api/releaseEmployeeDayLock",
    GET_DOCUMENT_ACCOUNT_LOCKED: "admin/api/getEmployeeList/travelled",
    GET_USER_SESSION: "admin/api/getUserSessionList",
    GET_USER_PROFILE: "admin/api/getUserProfileByEmployeeId",
    UPDATE_USER_PROFILE: "admin/api/updateUserProfile",
    UPDATE_ACCESS_CAN_LOGIN: "admin/api/updateUserAppAccess",
    UPDATE_EMPLOYEE_STATUS: "admin/api/updateEmployeeStatus",
    UPDATE_HR_USER_DATES: "admin/api/updateHrUserDates",
    GET_ATTENDANCE_LIST: "admin/api/getListAttendance",
    GET_SGPI_BY_EMPLOYEE_ID: "admin/api/getSgpiBalancesByEmployeeId",
    GET_EMPLOYEE_LEAVE_BALANCE: "admin/api/getLeaveBalanceByEmployee",
    GET_LEAVE_LIST_BY_EMPLOYEE: "admin/api/getLeaveListByEmployee",
    GET_DAILY_CALLS_BY_ATTENDANCE: "admin/api/getDailyCallsByAttendance",
    GET_ALL_POSITION_LIST: "admin/api/getAllPositionsList",
    GET_EXPENSE_SINGLE_DATE_BY_EMPLOYEE_ID:
      "admin/api/getExpenseSingleDateByEmployeeId",
    GET_EMPLOYEE_GEO_TOWN: "admin/api/getEmployeeGeoTown",
    GET_SINGLE_ATTENDANCE: "admin/api/getSingleAttendance",
    UPDATE_ATTENDANCE: "admin/api/UpdateAttendace",
    GET_BRANCHES: "admin/api/getBranches",
    REGENERATE_EXPENSE: "admin/api/regenerateExpense",
    ADD_EMPLOYEE_PROFILE: "admin/api/addEmployeeProfile",
    GET_POSITION_LIST_NEW: "admin/api/getPositionsListNew",
    GET_REPORTING_TO_BY_ORG_UNIT: "admin/api/getReportingToPositionsByOrgUnit",
    GET_POSITION_BY_ID: "admin/api/getSinglePositionsById",
    ADD_POSITIONS: "admin/api/addPositions",
    UPDATE_POSITIONS: "admin/api/updatePositions",
    RELEASE_ALL_DAY_LOCK: "admin/api/releaseAllLockDetails",
    GET_EMPLOYEE_LIST_EXCEL:"admin/api/getEmployeeListExcel",
    GET_ATTENDANCE_LIST_EXCEL: "admin/api/getListAttendanceExcel",
    GET_LEAVE_LIST_BY_EMPLOYEE_EXCEL: "admin/api/getLeaveListByEmployeeExcel",
    GET_SGPI_LIST_EXCEL: "admin/api/getSgpiBalancesByEmployeeIdExcel",
    GET_SGPI_TRANSACTION_LIST_EXCEL:"admin/api/creditSgpiHistoryExcel"



  },
  EDETAILING: {
    PLAYLIST_TYPE: "admin/api/playlistType/{id}",
    ED_PRESENTATION_DROPDOWN_DATA: "/admin/api/EdPresentationsDropdown",
    ADD_PLAYLIST_TYPE: "admin/api/addPlaylistType",
    UPDATE_PLAYLIST_TYPE: "admin/api/updateplaylistType",
    ED_PRESENTATIONS: "admin/api/EdPresentations",
    ADD_ED_PRESENTATIONS: "admin/api/addEdPresentations",
    UPDATE_ED_PRESENTATIONS: "admin/api/updateEdPresentations",
    PLAYLIST: "admin/api/playlist",
    ADD_PLAYLIST: "admin/api/addPlaylist",
    UPDATE_PLAYLIST: "admin/api/updatePlaylist",
    BRANDS: "admin/api/getBrands",
    PRESENTATION_TYPE: "admin/api/getPresentationType",
    OUTLET_TAGS: "admin/api/getOutletTags",
    LANGUAGES: "admin/api/getLanguages",
    GET_EXCEL_ED_PESENTATION:"admin/api/getEdPresentationsExcel",
    GET_EXCEL_ED_PLAYLIST:"admin/api/getEdPlaylistExcel"
    },
  CONFIGURATION: {
    // HOLIDAY
    GET_HOLIDAY_LIST: "admin/api/getAllHolidays",
    POST_AddHOLIDAY: "admin/api/addHoliday",
    PUT_UPDATE_HOLIDAY: "/admin/api/updateHoliday",
    GET_STATE_LIST: "/admin/api/getStateList",

    GET_EXPENSE_LIST: "admin/api/getAllExpenseHead",
    GET_SINGLE_EXPENSE: "admin/api/getSingleExpenseHead",
    GET_PURPOSE_LIST: "admin/api/getAllPurpose",
    POST_ADD_PURPOSE: "admin/api/addPurpose",
    PUT_UPDATE_PURPOSE: "admin/api/updatePurpose",
    GET_SINGLE_PURPOSE: "admin/api/getSinglePurpose",
    GET_CITY_LIST: "admin/api/getAllCityCategory",
    UPDATE_CITY: "admin/api/updateCityCategory",
    DELETE_CITY: "admin/api/deleteCityCategory",
    GET_ALL_CITY_AND_CATEGORY: "admin/api/getAllCityAndCategory",
    POST_ADD_CITY_CATEGORY: "admin/api/addCityCategory",
    GET_COMPANY_CONFIGURATION: "admin/api/getCompanyConfiguration",
    UPDATE_COMPANY_CONFIGURATION: "admin/api/updateCompanyConfiguration",
    GET_ACCESS_CONTROL: "admin/api/getAccessControl",
    UPDATE_ACCESS_CONTROL: "admin/api/updateAccessControl",
    GET_MODULE_WISE_CONFIGURATION: "admin/api/getModuleWiseConfiguration",
    UPDATE_MODULE_WISE_CONFIGURATION: "admin/api/updateModuleWiseConfiguration",
    WHEN_CAN_EMPLOYEE_SUBMIT_EXPENSES:
      "admin/api/whenCanEmployeeSubmitExpenses",
    EXPENSE_REMINDER: "admin/api/expenseReminder",
    TRIP_APPROVAL_RULE: "admin/api/tripApprovalRule",
    WHEN_CAN_EXPENSES_BOOKED: "admin/api/whenCanExpensesBooked",
    YES_OR_NO: "admin/api/yesOrNo",
    PAYMENT_SYSTEM: "admin/api/paymentSystem",
    AUTO_CALCULATED_TA: "admin/api/autoCalculatedTa",
    // add Expense head api//
    getPolicyKeys: "admin/api/getPolicyKeys",
    AddExpenseHead: "admin/api/addExpenseHead",
    updateExpenseHead: "admin/api/updateExpenseHead",

    //Grade Master API's
    GET_BUDGETS: "admin/api/getAllPurpose",
    ADD_GRADE_MASTER: "admin/api/addGradeMaster",
    EDIT_GRADE_MASTER: "admin/api/editGradeMaster",

    //Grade Policy API's
    GET_GRADE_POLICY: "admin/api/getGradePolicies",
    ADD_GRADE_POLICY: "admin/api/addGradePolicy",
    UPDATE_GRADE_POLICY: "admin/api/editGradePolicy",
    DELETE_GRADE_POLICY: "admin/api/deleteGradePolicy",

    //Policy Master
    GET_POLICY_MASTER: "admin/api/getPolicyMasters",
    ADD_POLICY_MASTER: "admin/api/addPolicyMaster",
    UPDATE_POLICY_MASTER: "admin/api/editPolicyMaster",

    GET_CURRENCIES: "admin/api/getCurrencies",

    //Notification configuration
    GET_NOTIFICATION_LIST: "/admin/api/getListNotificationConfigure",
    POS_ADD_NOTIFICATION: "/admin/api/AddNotificationConfigure",
    PUT_UPDATE_NOTIFICATIOIN: "/admin/api/UpdateNotificationConfigure",
    GET_SINGLE_NOTIFICATOIN: "/admin/api/getSingleNotificationConfigure",
    GET_ROLES_LIST: "/admin/api/getRolesList",
    GET_GRADE_LIST: "/admin/api/getGradeMasters",
    GET_POSITION_LIST: "/admin/api/getAllPositionsList",
    GET_EXCEL_DOWNLOAD_NOTI_CONFI:'admin/api/getListNotificationConfigureExcel',
    // Agenda
    GET_AGENDA_LIST: "/admin/api/getAgendaList",
    GET_AGENDA_CONTROL_TYPE_LIST: "/admin/api/getAgendaControlType",
    POST_ADD_AGENDA: "/admin/api/addAgenda",
    PUT_UPDATE_AGENDA: "/admin/api/updateAgenda",
    GET_AGENDA_SURVEY: "/admin/api/getAgendaSurveys",
    GET_ATTENDEES_SURVEYS: "/admin/api/getAttendeesSurveys",

    //Outcomes
    GET_OUTCOMES_LIST: "/admin/api/outcomeList",
    POST_ADD_OUTCOME: "/admin/api/addOutletOutcome",
    PUT_UPDATE_OUTCOME: "/admin/api/updateOutletOutcome",

    //TA Configuration
    GET_TA_CONFIGURATION: "/admin/api/taConfigurationList",
    GET_POLICY_KEY_LIST: "/admin/api/getPolicyKeys",
    POST_ADD_TA_CONFIGURATION: "/admin/api/taConfigurationAdd",
    PUT_UPDATE_TA: "/admin/api/taConfigurationUpdate",
  },
  SURVEY: {
    GET_CATEGORY_LIST: "/admin/api/getSurveyCategoriesList",
    GET_SURVEY_LIIST: "/admin/api/getSurveyList",
    POST_ADD_SUVERY: "/admin/api/addSurvey",
    PUT_UPDATE_SURVEY: "/admin/api/updateSurvey",
    GET_OUT_LET_TYPES: "/admin/api/getOutletTypes",
    GET_SURVEY_CATEGROY_TYPE: "/admin/api/getSurveyCategoryType",
    GET_SURVEYCONFIGURATION: "/admin/api/getSurveyConfiguration",
    GET_SURVEY_CATEGORY_LIIST: "/admin/api/getSurveyCategories",
    POST_ADD_SURVEY_CATEGORY: "/admin/api/addSurveyCategory",
    PUT_UPDATE_SURVEY_CATEGORY: "/admin/api/updateSurveyCategory",
    GET_SURVEY_QUESTION_LIST: "/admin/api/listSurveyQuestions",
    POST_ADD_SERVEY_QUESTION: "/admin/api/addSurveyQuestion",
    PUT_UPDATE_SERVEY_QUESTION: "/admin/api/updateSurveyQuestion",
    GET_EXCEL_DOWNLOAD:'admin/api/getSurveyListExcel',
    GET_EXCEL_DOWNLOAD_CAT:'admin/api/getSurveyCategoriesExcel',
    GET_EXCEL_DOWNLOAD_SURVEY_QUESTION:'admin/api/getSurveyQuestionsExcel'
  },
  EXPENSE: {
    GET_EXPENSE_LIST_ALL_UNITS: "admin/api/getExpenseListAllUnit",
    GET_EMPLOYEE_LIST_BY_UNIT: "admin/api/getEmployeeListByUnit",
    GET_EXPENSE_BY_EMPLOYEE_ID: "admin/api/getExpenseByEmployeeId",
    GET_EXPENSE_LIST_BY_DATE: "admin/api/getExpenseListByDate",
    GET_EXPENSE_DETAILS: "admin/api/getExpenseDetails",
    GET_EXPENSE_FW_DETAILS: "admin/api/getExpenseFWDetails",
    GET_EXPENSE_NCA_DETAILS: "admin/api/getExpenseNCADetails",
    GET_EXPENSE_LOG: "admin/api/getExpenseLog",
    GET_EXPENSE_STATUS: "/admin/api/getExpenseStatus",
    PUT_UPDATE_EXPESEN_AMOUNT: "/admin/api/updateExpenseAmount",
    GET_DAR_REPORT: "/admin/api/getDarReportApi",
    PUT_UPDATE_EXPENSE_STATUS :'/admin/api/updateExpenseStatus',
    GET_EXCEL_DOWNLOAD_UNITEXCEL: "admin/api/getExpenseListAllUnitExcel",
    GET_EXCEL_DOWNLOAD_EMP_LIST:'admin/api/getEmployeeListByUnitExcel',
    GET_EXCEL_DOWNLOAD_LIST_BY_DATE:'admin/api/getExpenseListByDateExcel'

  },
  MEDIA: {
    UPLOAD_MEDIA_BASE64: "api/uploadMediaBase64",
    GET_MEDIA_FILES_BY_IDS: "/admin/api/getMediaFilesByIds",
    UPLOAD_FILE: "/api/uploadFile",
  },
  FTP: {
    GET_FTP_IMPORT_LOGDASHBOARD: "/admin/api/getFTPImportLogsDashboard",
    GET_FTP_EXPORT_LOGDASHBOARD: "/admin/api/getFTPExportLogsDashboard",
    GET_FTP_IMPORT_LONGS: "/admin/api/getFTPImportLogs",
    GET_FTP_EXPOTLOGS: "/admin/api/getFTPExportLogs",
    GET_ORGANOGRAMLOGS: "/admin/api/getOrganogramLogs",
    PUT_RESET_FTPEXPORT: "/admin/api/resetFTPExportLog",
    PUT_RESET_ORGANOGRAMLOG: "/admin/api/resetOrganogramLog",
    PUT_RESET_FTPIMPORT: "/admin/api/resetFTPImportLog",
    GET_ORGANOGRAM_TYPES: "/admin/api/getOrganogramActionTypes",
    GET_ORGANOGRAM_STATUS: "/admin/api/getOrganogramStatus",
    GET_FTP_CONFIG: "/admin/api/getFTPConfigList",
    GET_FTP_CONFIG_BY_ID: "/admin/api/getFTPConfigById",
    ADD_FTP_CONFIG: "/admin/api/addFTPConfig",
    UPDATE_FTP_CONFIG: "/admin/api/updateFTPConfig",
    GET_FTP_EXPORT_BATCHES: "/admin/api/getFTPExportBatchesList",
    UPDATE_FTP_EXPORT_BATCHES: "/admin/api/updateFTPExportBatch",
    ADD_FTP_EXPORT_BATCHES: "/admin/api/addFTPExportBatch",
    GET_FTP_EXPORT_BATCH_BY_ID: "/admin/api/getFTPExportBatchById",
  },

  ProductCatalogue: {
    GET_ALL_CATEGORIES: "/admin/api/getAllCategories",
    GET_CATEGORY_PARENTID: "/admin/api/categoryParentId", // drop down
    POST_ADD_CATEGOTY: "/admin/api/addCategory",
    PUT_UPDATE_CATEGORY: "/admin/api/updateCategory",
    GET_CATEGORY_TYPE: "/admin/api/getCategoryTypes",
    DELETE_CATEGORY: "/admin/api/deleteCategory",
  },

  TAGES: {
    GET_TAGE: "/admin/api/getTags",
    POST_ADD_TAGES: "/admin/api/addTag",
    PUT_UPDATE_TAGES: "/admin/api/updateTag",
  },

  PRICE_BOOK: {
    GET_ALLPRICEBOOK: "/admin/api/getAllPriceBook",
    POST_ADD_PRICEBOOK: "/admin/api/addPriceBook",
    PUT_UPDATE_PRICEBOOK: "/admin/api/updatePriceBook",
    GET_PRICEBOOK_LIST: "/admin/api/priceBookLinesList",
    POST_SAVE_PRICEbOOK_LINES: "/admin/api/savePricebooklines",
  },
  POB: {
    GET_ORDER_LIST: "admin/api/getOrderList",
    GET_ORDER_LIST_BY_ID: "admin/api/getOrderById",
    EDIT_ACCEPT_ORDER: "admin/api/acceptOrder",
    DELETE_ORDER: "admin/api/deleteOrder",
    PRINT_ORDER: "admin/api/printOrder",
    PRODUCTS_BY_PRICEBOOKID: "admin/api/getProductsByPricebookId",
    ADD_ORDER_LINE: "admin/api/addOrderLine",
    EDIT_ORDER_LINE: "admin/api/editOrderLine",
    DELETE_ORDER_LINE: "admin/api/deleteOrderLine",
    GET_EMPLOYEE_FILTER: "admin/api/getEmployeeFilter",
    GET_ORDER_STATUS: "admin/api/getOrderStatus",
    GET_ORDER_LINE_SUBTOTAL: "admin/api/calculateOrderLineSubtotal",
    GET_ORDER_TYPES: "admin/api/getOrderTypes",
    GET_OUTLET_FILTERS: "/admin/api/getOutletsFilter",
    REJECT_ORDER: "/admin/api/rejectOrder",
    GET_EXCEL_FOR_ORDER_LIST:"admin/api/getOrderListExcel"
  },
  PRODUCT: {
    GET_PRODUCT_LIST: "/admin/api/getProductsList",
    GET_SINGLE_PRODUCT_BY_ID: "/admin/api/getSingleProducts",
    GET_BRANDS: "/admin/api/getBrandsList",
    GET_CATEGORY_LIST: "/admin/api/getAllCategories",
    GET_TAG_LIST: "/admin/api/getTags",
    GET_PACKAGE_LIST: "/admin/api/getPackageList",
    ADD_PRODUCT: "/admin/api/addProduct",
    UPDATE_PRODUCT: "/admin/api/updateProduct",
    GET_BRAND_COMPETITION_LIST: "/admin/api/getBrandCompetitionsList",
    GET_SINGLE_BRAND_COMPETITOR: "/admin/api/getSingleBrandCompetitions",
    ADD_BRAND_COMPETITOR: "/admin/api/addBrandCompetitions",
    UPDATE_BRAND_COMPETITOR: "/admin/api/updateBrandCompetitions",

    //Brand Step
    GET_BRAND_CAMPAIGN_STEP_LIST: "/admin/api/getBrandCampaignStepList",
    GET_AGENDA_SUB_TYPES: "/admin/api/getSubAgenda",
    POST_BRAND_CAMPAIGN_STEP_LIST: "/admin/api/addBrandCampaignSteps",
    POST_UPDATE_CAMPAIGN_STEP: "/admin/api/updateBrandCampaignStep",
    GET_SINGLE_BRNADCAMPAIGN_STEP: "/admin/api/getSingleBrandCampiagnStep",
  },

  Subscriber: {
    GET_SUBSCRIBER_TYPE: "/admin/api/getSubscriberTypes",
    ADD_SUBSCRIBER_TYPE: "/admin/api/addSubscriberType",
    GET_OUTLET_TYPE_LIST: "/admin/api/getOutletTypeList",
    UPDATE_SUBSCRIBER_TYPE: "/admin/api/updateSubscriberType",
    // Fields
    GET_SUBSCRIBER_FIELDS: "/admin/api/getSubscriberFields",
    ADD_SUBSCRIBER_FIELDS: "/admin/api/addSubscriberField",
    UPDATE_SUBSCRIBER_FIELDS: "/admin/api/updateSubscriberField",
    GET_SURVEY_QUESTION_TYPES: "/admin/api/getSurveyQuestionTypes",
    GET_STATUS_OPTIONS: "/admin/api/getStatusOptions",
  },
  Lead: {
    GET_LEAD_TYPES: "/admin/api/getLeadTypes",
    ADD_LEAD_TYPE: "/admin/api/addLeadType",
    UPDATE_LEAD_TYPE: "/admin/api/updateLeadType",
    // FIELDS
    GET_LEAD_FIELDS: "/admin/api/getLeadFields",
    ADD_LEAD_FIELD: "/admin/api/addLeadField",
    UPDATE_LEAD_FIELD: "/admin/api/updateLeadField",
  },
  Beat: {
    GET_TERRITORY_BY_ORGUNIT: "admin/api/getTerritoryByOrgUnit",
    GET_TERRITORY_BY_ID: "admin/api/getTerritoryById",
    GET_TOWN_BY_TERRITORYID_ORGUNITID:
      "admin/api/getTownByTerritoryIdOrgUnitId",
    GET_BEATS: "admin/api/getBeats",
    GET_BEAT_BY_ID: "admin/api/getBeat",
    ADD_BEAT: "/admin/api/addBeat",
    UPDATE_BEAT: "/admin/api/updateBeat",
    GET_BEAT_OUTLETS: "/admin/api/getBeatOutlets",
    GET_TERRITORY_TOWN_FILTER: "/admin/api/getTerritoryTownsFilter",
    GET_TOWN_FILTER: "/admin/api/getTownsFilter",
    GET_EXCET_BEAT:"admin/api/getBeatsExcel",
    GET_EXCEL_BEAT_TERRITORIES :'admin/api/getAllTerritoriesListExcel'
  },
  BRAND_CAMPAIGN: {
    GET_BRAND_CAMPAIGN_LIST: "admin/api/getBrandCampaignList",
    GET_BRAND_CAMPAIGN_OUTLET: "admin/api/getOutletinCampaign",
    GET_SINGLE_BRAND_CAMPAIGN: "admin/api/getSingleBrandCampaign",
    GET_OUTLET_TYPE_LIST: "admin/api/getOutletTypeList",
    GET_CLASSIFICATION: "admin/api/getClassificationList",
    GET_BRANDS: "admin/api/getBrandsList",
    GET_BRAND_CAMPAIGN_STATUS: "admin/api/getBrandCampaignStatus",
    GET_DESIGNATION_POSITION: "admin/api/getDesignationPositionFilter",
    GET_SGPI_LISTS: "admin/api/getSGPILists",
    ADD_BRAND_CAMPAIGN: "admin/api/addBrandCampaign",
    UPDATE_BRAND_CAMPAIGN: "/admin/api/updateBrandCampaign",
    UPDATE_OUTLET_CAMPAIGN: "/admin/api/addOutletinCampaign",
    PUBLISH_BRAND_CAMPAIGN_STATUS_CHANGE:"/admin/api/publishBrandCampaignStatusChange",
    GET_BRAND_CAMPAIGN_LIST_EXCE:"admin/api/getSingleBrandCampaignExcel",
    GET_BRAND_OUTLET_CAMPAIGN_EXCEL:"admin/api/getOutletinCampaignExcel",
    GET_BRAND_CAMPIAGN_STEP_EXCEL:"admin/api/getBrandCampiagnStepListExcel"
  },
  Brnad: {
    GET_Brand_LIST: "/admin/api/getBrandsList",
    POST_ADD_BRAND: "/admin/api/AddBrand",
    POST_UPDATE_BRAND: "/admin/api/updateBrand",
  },
  Terrritoris: {
    GET_TERRITORIS_LIST: "/admin/api/getAllTerritoriesList",
    GET_TERRITORIS_TOWN_LIST: "/admin/api/getTerritoryTown",
    GET_POSITION_LIST: "/admin/api/getAllPositionList",
    POST_ADD_TERRIORTY: "/admin/api/AddTerritory",
    PUT_UPADATE_TERRITORY: "/admin/api/UpdateTerritory",

    GET_ASSIGNTOTRIP_TYPES: "/admin/api/getAssignToTripTypes",
    GET_OTHERS_TRIP_TYPES: "/admin/api/getOthersTripTypes",
    GET_SEARCH_LOCATIONS: "/admin/api/searchLocations",
    POST_ADD_TERRITORY_TOWN: "/admin/api/AddTerritoryTown",
    PUT_UPDATE_TERRITORY_TOWN: "/admin/api/UpdateTerritoryTown",
  },
  ONBOARDING: {
    GET_ORG_UNIT_LIST: "admin/api/getUnitGroupWiseList",
    GET_ONBOARD_REQUEST_LIST: "admin/api/getOnboardingRequests",
    GET_ONBOARDING_STATUS: "admin/api/getOnboardingStatus",
    GET_OUTLET_TYPES: "admin/api/getOutletTypes",
    GET_TERRITORIES: "admin/api/getAllTerritoriesList",
    GET_ONBOARD_EDM_DETAILS: "admin/api/getOnboardingEDMDetails",
    GET_ONBOARD_ADDRESS_LIST: "admin/api/getOnboardingAddressLists",
    GET_ORGANIZATION_RECORDS_LISTS: "admin/api/getOrganizationRecordsLists",
    GET_ONBOARDING_REQUEST_LOGS: "admin/api/getOnboardingRequestLog",
    ADD_ONBOARD_REQURIED: "admin/api/addOnboardRequired",
    GET_ONBOARD_REQURIED_FIELD_LIST: "admin/api/getOnBoardRequiredFieldsList",
    GET_ONBOARD_SINGLE_ADDRESS: "admin/api/getSingleAddressById",
    GET_OUTLET_VISIT_FREQUENCY: "admin/api/getOutletVisitFrequency",
    GET_STATE_LIST: "admin/api/getStateList",
    GET_ALL_POSITION: "admin/api/getAllPositionsList",
    UPDATE_ONBOARDING_REQUEST: "/admin/api/updateOnboardingRequest",
    GET_ALL_TOWNS: "admin/api/getTownsFilter",
    GET_CITY_STATE: "admin/api/getCityStateByTownId",
    GET_CLASSIFICATION: "admin/api/getClassificationList",
    UPDATE_ADDRESS: "admin/api/updateOnBoardRequestAddress",
    BULK_ONBOARDING_REQUEST: "/admin/api/changeStatusBulkOnboardingRequest",
    // GET_SINGLE_ADDRESS: "admin/api/getSingleAddressById",
    API_ONBOARD_WINDOW: "admin/api/apiOnboardWindow",
    ONBOARDING_REQUEST_EXCEL:"admin/api/getOnboardingRequestsExcel",
    GET_TERRITORY_EXCEL:"admin/api/getAllTerritoriesListExcel"
  },
  Cutomer: {
    //Classification
    GET_CLASSIFICATION_LIST: "/admin/api/getClassificationList",
    ADD_CLASSIFICATION: "/admin/api/addClassification",
    UPDATE_CLASSIFICATION: "/admin/api/updateClassification",
    // Outlet Tag
    GET_OUTLET_TAGS_LIST: "/admin/api/getOutletTagsList",
    ADD_OUTLET_TAG: "/admin/api/addOutletTag",
    UPDATE_OUTLET_TAG: "/admin/api/updateOutletTag",
    GET_OUTLET_LIST: "/admin/api/getOutletsList",
    ADD_OUTLET: "/admin/api/addOutlet",
    GET_OUTLET_SALUTATION: "/admin/api/getOutletSalutations",
    GET_OUTLET_MARITAL_STATUS: "/admin/api/getOutletMaritalStatus",
    GET_OUTLET_STATUS: "/admin/api/getOutletStatus",
    GET_OUTLET_BY_ID: "/admin/api/getOutletById",
    UPDATE_OUTLET: "/admin/api/updateOutlet",
    GET_ALL_TOWNS: "/admin/api/getTownsFilter",
    GET_ADDRESS_TYPE: "/admin/api/getOutletAddressTypes",
    GET_CITY_STATE_BY_TOWN: "/admin/api/getCityStateByTownId",
    GET_OUTLET_ADDRESS_LIST: "/admin/api/getOutletAddressList",
    GET_OUTLET_ADDRESS_BY_ID: "/admin/api/getOutletAddressById",
    GET_OUTLET_ORGANIZATION_LIST: "/admin/api/getOutletOrgDataList",
    GET_OUTLET_ORGANIZATION_DATA_BY_ID: "/admin/api/getOutletOrgDataById",
    ADD_OUTLET_ADDRESS: "/admin/api/addOutletAddress",
    UPDATE_OUTLET_ADDRESS: "/admin/api/updateOutletAddress",
    GET_OUTLET_VISIT_FREQUENCY: "/admin/api/getOutletVisitFrequency",
    ADD_OUTLET_ORG_DATA: "/admin/api/addOutletOrgData",
    UPDATE_OUTLET_ORG_DATA: "/admin/api/updateOutletOrgData",
    GET_OUTLET_MAPPING_LIST: "/admin/api/getOutletMappingList",
    GET_OUTLET_MAPPING_BY_ID: "/admin/api/getOutletMappingById",
    GET_OUTLET_CATEGORY_TYPE: "/admin/api/getOutletCategoryTypes",
    GET_OUTLET_PARENT: "/admin/api/getOutletParent",
    GET_OUTLET_QUALIFICATION_LIST: "/admin/api/getOutletQualificationList",
    ADD_OUTLET_MAPPING: "/admin/api/addOutletMapping",
    UPDATE_OUTLET_MAPPING: "/admin/api/updateOutletMapping",
    GET_OUTLET_DCR_SUMMARY: "/admin/api/getOutletDCRSummary",
    GET_OUTLET_SGPI_OUT_SUMMARY: "/admin/api/getOutletSGPIOutSummary",
    GET_OUTLET_RCPA_SUMMARY: "/admin/api/getOutletRCPASummary",
    GET_OUTLET_INVENTORY: "/admin/api/getOutletStockList",
    UPDATE_OUTLET_INVENTORY: "/admin/api/updateOutletStock",
    GET_OUTLET_ORG_NOTE_LIST: "/admin/api/getOutletOrgNotesList",
    GET_OUTLET_ORG_NOTE_BY_ID: "/admin/api/getOutletOrgNoteById",
    ADD_OUTLET_ORG_NOTE: "/admin/api/addOutletOrgNote",
    UPDATE_OUTLET_ORG_NOTE: "/admin/api/updateOutletOrgNote",
    GET_BEAT_OUTLET_LIST: "/admin/api/getBeatOutletList",
    GET_BEAT_OUTLET_BY_ID: "/admin/api/getBeatOutletById",
    ADD_BEAT_OUTLET: "/admin/api/addBeatOutlet",
    UPDATE_BEAT_OUTLET: "/admin/api/updateBeatOutlet",
    GET_BEAT_OUTLET_STATUS: "/admin/api/getBeatOutletStatus",
    GET_OUTLETS_LIST_EXCEL:"/admin/api/getOutletsListExcel",
    GET_CLASSIFICATION_LIST_EXCEL:"/admin/api/getClassificationListExcel"
  },
  MATERIAL: {
    GET_FOLDER_LIST: "/admin/api/folders",
    GET_FOLDER_PARENT: "/admin/api/folders/parents",
    ADD_FOLDER: "/admin/api/folder",
    GET_FOLDER_SINGLE_LIST: "/admin/api/folder",
    UPDATE_FOLDER: "/admin/api/folder",
    GET_FILES_LISTS: "/admin/api/files",
    ADD_FILE: "/admin/api/file",
    UPDATE_FILE: "/admin/api/file",
    GET_MEDIA_CONFIG: "/admin/api/getMediaConfigs",
    ADD_MEDIA_CONFIG: "/admin/api/addMediaConfig",
    UPDATE_MEDIA_CONFIG: "/admin/api/updateMediaConfig",
  },
  GEO_DISTANCE: {
    GET_GEO_DISTANCE_LIST: "/admin/api/getGeoDistanceList",
    POST_ADD_GEO_DISTANCE: "/admin/api/addGeoDistance",
    PUT_UPDATE_GEO_DISTANCE: "/admin/api/updateGeoDistance",
    GET_CONFIG_STATUS: "/admin/api/getConfigStatus",
    GET_GEO_TOWN_LIST: "/admin/api/getTownLocation",
    GET_GEO_TOWN_LIST_2: "/admin/api/getTownLocation",
    GET_EXCEL_DOWNLOAD :"admin/api/getGeoDistanceListExcel"
  },

  EXPENSE_NOTIFY: {
    GET_EXPENSE_NOTIFY_LIST: "/admin/api/getExpenseNotifyLists",
    GET_EXPENSE_NOTIFY_NOTIFICATION: "/admin/api/getSendNotification",
    GET_EXCEL_DOWNLOAD:'/admin/api/getExpenseNotifyListsExcel'
  },
  // GEO_DISTANCE: {
  //   GET_GEO_DISTANCE_LIST: "/admin/api/getGeoDistanceList",
  //   POST_ADD_GEO_DISTANCE: "/admin/api/addGeoDistance",
  // },
  SETTING: {
    GET_LANGUAGE_LIST: "/admin/api/getLanguagesList",
    POST_ADD_LANGUAGE: "/admin/api/addLanguage",
    PUT_Update_LANGUAGE: "/admin/api/updateLanguage",
    GET_SUPER_SETTING_COMPANY_LIST: "/admin/api/getCompanyConfiguration",
    GET_CURRENCY_LIST: "/admin/api/currency",

    GET_COMPANY_LIST: "/admin/api/getCompanies",
    GET_AdminCurrencies: "/admin/api/getAdminCurrencies",
    POST_ADD_COMPANY: "/admin/api/addCompany",
    PUT_UPDATE_COMPANY: "/admin/api/updateCompany",

    GET_ORG_UNIT_LIST: "/admin/api/getOrgUnitList",
    GET_COUNTRY_LIST: "/admin/api/getAllCountries",
    POST_ADD_ORG_UNIT: "/admin/api/addOrgUnit",
    PUT_UPDATE_ORG_UNIT: "/admin/api/updateOrgUnit",
    GET_USER_CONFIG: "/admin/api/getUserConfigStatus",

    GET_BRANCH_LIST: "/admin/api/getBranchList",
    ADD_BRANCH: "/admin/api/addBranch",
    UPDATE_BRANCH: "/admin/api/updateBranch",

    GET_DESIGNATION: "/admin/api/getDesignationList",
    GET_DESIGNATIONS_COLOR: "/admin/api/getDesignationColors",
    ADD_DESIGNATION: "/admin/api/addDesignation",
    UPDATE_DESIGNATION: "/admin/api/updateDesignation",

    //  GET_COMPANY_LIST:'/admin/api/getCompanies',
    //  GET_AdminCurrencies :'/admin/api/getAdminCurrencies',
    //  POST_ADD_COMPANY:'/admin/api/addCompany',
    //  PUT_UPDATE_COMPANY:'/admin/api/updateCompany',

    GET_USER_MANAGEMENT: "/admin/api/getUserLists",
    PUT_UPDATE_USER: "/admin/api/updateUser",
    GET_USER_CONFIG_STATUS: "/admin/api/getUserConfigStatus",

    GET_OUTLET_TYPE_LIST: "/admin/api/getOutletTypeList",
    ADD_OUTLET_TYPES: "/admin/api/addOutletType",
    UPDATE_OUTLET_TYPES: "/admin/api/updateOutletType",

    GET_OUTLET_TYPES_MODULE: "/admin/api/getOutlettypeModulesList",
    ADD_OUTLET_TYPES_MODULE: "/admin/api/addOutlettypeModules",
    UPDATE_OUTLET_TYPES_MODULE: "/admin/api/updateOutlettypeModules",

    GET_ALL_COUNTRIES: "/admin/api/getAllCountries",
    ADD_COUNTRY: "/admin/api/addCountry",
    UPDATE_COUNTRY: "/admin/api/updateCountry",

    GET_ROLES_LIST: "/admin/api/getAdminRoles",
    ADD_ROLES: "/admin/api/addRole",
    UPDATE_ROLES: "/admin/api/updateRoles",
    GET_ROLES_PERMISSION: "/admin/api/getRolePermissions",

    GET_FTP_IMPORT_BATCHES_LIST: "/admin/api/getFTPImportBatchesList",
    GET_FTP_IMPORT_BATCH_BY_ID: "/admin/api/getFTPImportBatchById",
    ADD_FTP_IMPORT_BATCH: "/admin/api/addFTPImportBatch",
    UPDATE_FTP_IMPORT_BATCH: "/admin/api/updateFTPImportBatch",

    GET_CURRENCIES_LIST: "/admin/api/listCurrencies",
    ADD_CURRENCY: "/admin/api/addCurrency",
    UPDATE_CURRENCY: "/admin/api/updateCurrency",

    GET_ORG_STRUCTURE_TREE: "/admin/api/orgStructure/tree",
    UPDATE_CAV_ORG_STRUCTURE_TREE: "/admin/api/org-structure/update-cav",
  },
  STP: {
    GET_STP_LIST: "/admin/api/getStpList",
    UPDATE_STP: "/admin/api/updateStp",
    GET_STP_WEEKS_BY_STP: "/admin/api/getStpWeeksByStpId",
    UPDATE_STP_WEEK: "/admin/api/updateStpWeek",
    GET_TERRITORY_BY_EMP_ID: "/admin/api/getTerritoriesByEmployee",
  },
  OFFERS: {
    GET_OFFERS_LIST: "/admin/api/getOfferList",
    GET_SINGLE_OFFERS_LIST: "/admin/api/getOfferById",
    ADD_OFFER: "/admin/api/addOffer",
    UPDATE_OFFER: "/admin/api/updateOffer",
  },
  SGPI: {
    GET_SGPI_LISTS: "/admin/api/getSGPILists",
    GET_TRANSACTION_LIST: "/admin/api/getTransactionLists",
    GET_BALANCE_SGPI_LISTS: "/admin/api/getSgpiBalanceList",
    ADD_TRANSACTION: "/admin/api/addTransaction",
    GET_SGPI_STATUS: "/admin/api/getSGPIStatus",
    ADD_SGPI: "/admin/api/AddSGPI",
    GET_SGPI_FILTER: "/admin/api/getSgpiFilter",
    GET_SGPI_ACCOUNT_FILTER: "/admin/api/getSGPIAccountFilter",
    UPDATE_SGPI_TRANSACTION: "/admin/api/updateTransaction",
    UPDATE_SGPI: "/admin/api/updateSGPI",
    GET_SGPI_LISTS_EXCEL: "/admin/api/getSGPIListExcel",
    GET_BALANCE_SGPI_LISTS_EXCEL: "/admin/api/getSgpiBalanceListExcel",
    GET_TRANSACTION_LIST_EXCEL: "/admin/api/getTransactionListExcel",



  },
  ANNOUNCEMENT: {
    GET_ANNOUNCEMENT_LIST: "/admin/api/getAnnouncementsList",
    GET_ANNOUNCEMENT_BY_ID: "/admin/api/getAnnouncementById",
    ADD_ANNOUNCEMENT: "/admin/api/addAnnouncement",
    UPDATE_ANNOUNCEMENT: "/admin/api/updateAnnouncement",
    ANNOUNCEMENT_PUSH_NOTIFICATION: "/admin/api/pushNotification",
  },
  MTP: {
    GET_MTP_LIST: "/admin/api/getMTPList",
    GET_MTP_MONTHS: "/admin/api/getMTPMonths",
    GET_MTP_STATUS: "/admin/api/getMTPStatus",
    GET_MTP_ACTIONS: "/admin/api/getMTPActions",
    ADD_MTP_FOR_MONTH: "/admin/api/addMTPForMonth",
    UPDATE_MTP_STATUS: "/admin/api/updateMTPStatus",
    GET_MTP_DAY_BY_ID: "/admin/api/getMtpDayByMtpId",
    GET_TOUR_PLAN_BY_MTP_DAY_ID: "/admin/api/getTourplanByMtpDayId",
    ADD_TOUR_PLAM: "/admin/api/addTourplan",
    UPDATE_MTP_TOUR_PLAN: "/admin/api/updateTourplan",
    GET_MTP_DAY_CUSTOMER: "/admin/api/getMtpDayCustomers",

    GET_MTP_DAY_BEAT_TOWN: "/admin/api/getMtpDayBeatTown",
    GET_MTP_TERRITORIES: "/admin/api/getTerritoriesForMTP",
  },
  TICKET: {
    GET_TICKET_TYPE_LIST: "/admin/api/getTicketTypeList",
    GET_TICKET_LIST: "/admin/api/getTicketList",
    GET_TICKET_CONFIG_STATUS: "/admin/api/getConfigTicketStatus",
    ADD_TICKET: "/admin/api/addTicket",
    UPDATE_TICKET: "/admin/api/updateTicket",
    GET_TICKET_REPLIES: "/admin/api/getTicketCommentByTicketId",
    ADD_TICKET_REPLIES: "/admin/api/addTicketComment",
    UPDATE_TICKET_REPLIES: "/admin/api/updateTicketComment",
  },
  Reports: {
    GET_EMPLOYEE_REPORT: "/admin/api/getEmployeeReport",
    GET_MONTH_YEAR_FILTER: "/admin/api/getMonthYearFilter",
    GET_EMPOLYEE_VISITS: "/admin/api/getEmployeeVisits",

    //Dar Report
    GET_EMPOLYEE_FILTER: "/admin/api/getEmployeeFilter",
    GET_DAR_REPORT: "/admin/api/getDARReport",

    //Admin Report
    GET_ADMIN_REPORT: "/admin/api/getAdminReport",

    //Mas REport 
    GET_MAS_REPORT:'/admin/api/getMasReport',

    // onBoarding Report
    GET_ONBOARDING_REPORT:'/admin/api/getOnboardingReport',
    
    // DCR Report
    GET_DCR_REPORT:'/admin/api/getDCRReport',

    //Attendance report
    GET_ATTENDANCE_REPORT:'/admin/api/getAttendanceReport',

    GET_DAILY_CALL_REPORT:'/admin/api/getDailyCallReport',
    GET_PLAN_VS_ACTUAL_REPORT:'/admin/api/getPlanVsActualReport',

    //Customer Data Report
    GET_CUSTOMER_DATA_REPORT:'/admin/api/getCustomerDataReport',

    // Get DCR v2
    POST_DRC_REPORT_VERSION_2:"admin/api/getDCRReportv2" 
  },
  GLOBAL_EXCEL:{
    EXCEL_DOWNLOAD:"/admin/api/getFileDownloadStatus"
  }
};
